var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkipPrevious48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0v48h48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 22.679v-5.87a1.2 1.2 0 0 0-1.792-1.045L9.51 22.956a1.2 1.2 0 0 0 0 2.089l12.697 7.192a1.2 1.2 0 0 0 1.791-1.044V25.32l12.21 6.916A1.2 1.2 0 0 0 38 31.192V16.807a1.2 1.2 0 0 0-1.791-1.044l-12.21 6.916z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipPrevious48);
export default __webpack_public_path__ + "static/media/skip_previous_48.b7a307d4.svg";
export { ForwardRef as ReactComponent };